import React from 'react';
import { FolderOpen } from 'lucide-react';

interface ProjectEmptyStateProps {
  title: string;
  description?: string;
  action?: React.ReactNode;
}

export const ProjectEmptyState: React.FC<ProjectEmptyStateProps> = ({
  title,
  description,
  action,
}) => (
  <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-gray-300 bg-white px-6 py-14 text-center dark:border-slate-600 dark:bg-slate-800">
    <FolderOpen size={44} className="mb-3 text-gray-300 dark:text-slate-600" />
    <p className="font-medium text-gray-800 dark:text-slate-200">{title}</p>
    {description && (
      <p className="mt-1 max-w-sm text-sm text-gray-500 dark:text-slate-400">{description}</p>
    )}
    {action && <div className="mt-4">{action}</div>}
  </div>
);
